<template>
  <div class="xxjj">
    <headerNav></headerNav>

    <div class="content">
      <div class="listLeft">
        <div class="leftTop">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/logo.png"
            alt=""
          />
          <div class="leftTitle">
            <div>服务保障</div>
          </div>
        </div>
        <ul class="listUl">
          <li
            v-for="(item, index) in twoList"
            :key="index"
            :class="[item.title == '学生校服' ? 'activeTitle' : 'normalTitle']"
            @click="toSkip(item.title)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>

      <div class="listRight">
        <div class="listRightHeader">
          <p class="headerTitle">学生校服</p>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xqLine.png"
          alt=""
          class="endLine"
        />
        <div class="newMian">
          <div v-if="!isHave">
            <p>敬请期待...</p>
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/logoBg.png"
              alt=""
              class="dengdai"
            />
          </div>

          <div
            v-if="isHave"
            class="newsItem"
            v-for="(item, index) in rightData"
            :key="index"
            @click="toDetail(item.id)"
          >
            <img :src="item.img" alt="" />
            <div class="newsRight">
              <div class="newsTitle">{{ item.title }}</div>
              <div class="zuozhe">
                {{ item.createTime }}
              </div>
            </div>
          </div>

          <div class="page" v-if="isHave">
            <el-pagination
              background
              page-size="4"
              layout="prev, pager, next"
              :total="total"
              @prev-click="previ"
              @next-click="next"
              @current-change="getPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import headerNav from "../../components/headerNav.vue";
import Footer from "../../components/footer.vue";
export default {
  name: "xxjj",
  components: { headerNav, Footer },
  data() {
    return {
      leftTitle: "",
      isHave: false,
      rightData: [],
      twoList: [],
    };
  },
  created() {},
  mounted() {
    this.api.navTwo({ id: 5 }).then((res) => {
      this.twoList = res.data;
      this.api.fwbzApi({ type: "学生校服", page: 1, limit: 4 }).then((res) => {
        this.leftTitle = res.data[0];
        if (res.data[1].list.length != 0) {
          this.isHave = true;
          console.log(res.data);
          this.rightData = res.data[1].list;
          this.total = res.data[1].total;
        } else {
          this.isHave = false;
        }
      });
    });
  },
  methods: {
    //  下一页
    next(e) {
      this.api.fwbzApi({ type: "学生校服", page: e, limit: 4 }).then((res) => {
        this.rightData = res.data[1].list;
        this.total = res.data[1].total;
      });
    },
    // 上一页
    previ(e) {
      this.api.fwbzApi({ type: "学生校服", page: e, limit: 4 }).then((res) => {
        this.rightData = res.data[1].list;
        this.total = res.data[1].total;
      });
    },
    // 页数
    getPage(e) {
      this.api.fwbzApi({ type: "学生校服", page: e, limit: 4 }).then((res) => {
        this.rightData = res.data[1].list;
        this.total = res.data[1].total;
      });
    },
    toSkip(e) {
     if (e == "学生住宿") {
        this.$router.push("/zhusu");
      } else if (e == "学生餐饮") {
        this.$router.push("/canyin");
      } else if (e == "校车服务") {
        this.$router.push("/xiaoche");
      }
    },

    toDetail(e) {
      this.$router.push({ path: "/xiaofuDetail", query: { id: e } });
    },
  },
};
</script>
<style scoped>
.xxjj {
  background: rgb(241, 241, 241);
}
.list {
}
li {
  list-style: none;
}
.content {
  min-width: 1200px;
  display: flex;
  justify-content: center;
  /* padding: 0 360px; */
  margin-top: 50px;
  margin-bottom: 85px;
}
.listLeft {
  width: 300px;
  background-color: white;
  box-shadow: 0px 5px 16px 0px rgba(37, 64, 107, 0.2);
  margin-right: 71px;
}
.leftTop {
  width: 270px;
  height: 75px;
  display: flex;
  padding: 20px 15px;
  justify-content: space-around;
  background: rgb(152, 33, 35);
}
.leftTop img {
  width: 80px;
  height: 80px;
  display: block;
}
.leftTitle div:nth-child(1) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: left;
  margin-top: 10px;
}
.leftTitle div:nth-child(2) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: left;
  margin-top: 10px;
}

.normalTitle {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  border-bottom: 1px solid rgb(219, 218, 218);
  color: rgb(64, 64, 64);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 3px;
  text-align: center;
  cursor: pointer;
}

.activeTitle {
  width: 100%;
  padding: 20px 0;
  color: rgb(191, 110, 18);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 3px;
  text-align: center;
  background: rgb(255, 227, 227);
  cursor: pointer;
}

.listRight {
  width: 838px;
  padding: 0 20px;
  background: rgb(255, 255, 255);
}
.listRightHeader {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0%;
  text-align: left;
  margin: 20px 0;
}

.headerTitle {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #992223;
  margin-left: 18px;
  margin-right: 7px;
}
.endLine {
  width: 838px;
  height: 12px;
}
.titleAritcle {
  color: rgb(64, 64, 64);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.newMian {
}
.newMian p {
  margin-top: 15px;
  color: rgb(64, 64, 64);
}
.dengdai {
  width: 234px;
  height: 234px;
  margin: 100px auto;
  display: block;
}

.newsItem {
  width: 100%;
  padding: 30px 0;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid rgb(210, 210, 210);
  cursor: pointer;
}
.newsItem img {
  width: 154px;
  height: 72px;
  border-radius: 9px;
}
.newsRight {
  width: 670px;
  margin-left: 15px;
}
.newsTitle {
  color: rgba(0, 0, 0, 0.8);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 15px;
}

.zuozhe {
  color: rgba(0, 0, 0, 0.3);
  font-family: 思源黑体;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}

.page {
  text-align: center;
  margin: 20px 0;
  padding-bottom: 50px;
}
div /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #992223 !important;
  color: #fff;
}

@media screen and (max-width: 1440px) {
  .leftTitle div:nth-child(2) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 3px;
    text-align: left;
    margin-top: 0px;
  }
}

@media screen and (max-width: 450px) {
  .xxjj {
    background: rgb(241, 241, 241);
  }

  li {
    list-style: none;
  }
  .content {
    min-width: 350px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 85px;
  }
  .listLeft {
    width: 120px;
    background-color: white;
    box-shadow: 0px 2px 5px 0px rgba(37, 64, 107, 0.2);
    margin-right: 5px;
  }
  .leftTop {
    width: 110px;
    height: 55px;
    display: flex;
    padding: 5px;
    justify-content: space-around;
    background: rgb(152, 33, 35);
  }
  .leftTop img {
    width: 30px;
    height: 30px;
    display: block;
    margin-right: 0px;
  }
  .leftTitle div:nth-child(1) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 3px;
    text-align: left;
    margin-top: 5px;
  }
  .leftTitle div:nth-child(2) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 5px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 0px;
  }
  .normalTitle {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid rgb(219, 218, 218);
    color: rgb(64, 64, 64);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 3px;
    text-align: center;
    cursor: pointer;
  }

  .activeTitle {
    width: 100%;
    padding: 10px 0;
    color: rgb(191, 110, 18);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 3px;
    text-align: center;
    background: rgb(255, 227, 227);
    cursor: pointer;
  }

  .listRight {
    width: 200px;
    padding: 0 10px;
    background: rgb(255, 255, 255);
  }
  .listRightHeader {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-weight: 700;
    letter-spacing: 0%;
    text-align: left;
    margin: 10px 0;
  }

  .headerTitle {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #992223;
    margin-left: 18px;
    margin-right: 7px;
  }
  .endLine {
    width: 200px;
    height: 5px;
  }

  .dengdai {
    width: 134px;
    height: 134px;
    margin: 50px auto;
    display: block;
  }
  .titleAritcle {
    color: rgb(64, 64, 64);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .fuwenben {
    padding-bottom: 50px;
    font-size: 10px;
  }
}
</style>
